import Component from "../../lib/component";

export const SelecterItemsInfoConfig = {
    componentTypeKey: 'SelecterItemsInfo',
    baseHtmlClass: 'selector__items_info',
    selector: '.selector__items_info',
};

export class SelecterItemsInfo extends Component {

    static createElement() {
        let element = document.createElement('div');
        element.classList.add(SelecterItemsInfoConfig.baseHtmlClass);
        return element;
    }

    constructor(id_or_element, selecter) {
        super({
            element: id_or_element,
            config: SelecterItemsInfoConfig
        });

        this.selecter = selecter;

    }

    render() {
        let content = '';
        const selectedItems = this.getSelectedItems();
        let itemsContent = `<ul class="selector_item_labels">${
            selectedItems.map((item)=>{
                return `<li>${ item.getLabelHtml() }</li>`;
            }).join(' ')
        }</ul>`;

        let selectedStatement = `${ selectedItems.length } ${ (selectedItems.length === 1) ? 'item' : 'items' } selected`;
        content = `
<p><a href="javascript:void(0);" class="popover" data-popover-source="${ this.id }_foo">${ selectedStatement }</a></p>

<div id="${ this.id }_foo" class="hide">
    ${ itemsContent }
</div>
`;

        this.element.innerHTML = content;
    }

    getSelectedItems() {
        return this.selecter.selectedItems();
    }

}

